import React from 'react';
import { BLOCKER_FONT_SIZE, BLOCKER_LINE_HEIGHT } from './blockerCardMetrics';

/**
 * BlockerLayer — blocker cards, drawn where the layout put them.
 *
 * A blocker used to be furniture hung off a connector: the arrow measured its
 * own curve, worked out where a card would fit, and drew the whole stack
 * itself. That made one edge responsible for geometry, hit-testing and
 * rendering of objects that are not edges, and it meant everything else on the
 * map — link handles, routed blocking lines, the layout's own row heights —
 * had to reach back into the arrow to find out where a blocker was.
 *
 * They are nodes in a column now. The layout places them, this draws them, and
 * everything else reads the same positions.
 */
export default function BlockerLayer({ boxes = [], onBlockerClick, litIds = null }) {
  if (!boxes.length) return null;

  return (
    <g className="blocker-layer">
      {boxes.map((box) => {
        const firstLineY = box.y - ((box.lines.length - 1) * BLOCKER_LINE_HEIGHT) / 2;
        return (
          <g
            key={box.id}
            className="blocker-card"
            opacity={litIds && !litIds.has(box.id) ? 0.09 : 1}
            style={{ cursor: onBlockerClick ? 'pointer' : 'default', transition: 'opacity 0.18s ease' }}
            onClick={(e) => {
              if (!onBlockerClick) return;
              e.stopPropagation();
              const rect = e.currentTarget.getBoundingClientRect();
              onBlockerClick(box.blocker, {
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2,
                centered: true,
              });
            }}
          >
            <rect
              x={box.x - box.width / 2}
              y={box.y - box.height / 2}
              width={box.width}
              height={box.height}
              rx={10}
              fill="#2A1113"
              stroke="#EF5350"
              strokeWidth={2}
            />
            <text
              textAnchor="middle"
              fontSize={BLOCKER_FONT_SIZE}
              fontWeight={600}
              fill="#FF8A85"
              style={{ userSelect: 'none', pointerEvents: 'none' }}
            >
              {box.lines.map((line, i) => (
                <tspan key={line + i} x={box.x} y={firstLineY + i * BLOCKER_LINE_HEIGHT} dominantBaseline="central">
                  {line}
                </tspan>
              ))}
            </text>
          </g>
        );
      })}
    </g>
  );
}
